import React from 'react';

class SessionExpiredPopup extends React.Component {
  handleStartAgain = () => {
    if (this.props.onStartAgain) {
      this.props.onStartAgain();
    }
  }

  render() {
    return (
      <div className="session-expired-overlay">
        <div className="session-expired-dialog">
          <div className="session-expired-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" stroke="#e8512f" strokeWidth="2">
              <circle cx="12" cy="12" r="10" />
              <line x1="12" y1="8" x2="12" y2="12" />
              <line x1="12" y1="16" x2="12.01" y2="16" />
            </svg>
          </div>
          <h3 className="session-expired-title">{this.props.title || 'Session Expired'}</h3>
          <p className="session-expired-message">
            {this.props.message || 'Your session has expired. All seat selections have been released.'}
          </p>
          <button
            type="button"
            className="session-expired-btn"
            onClick={this.handleStartAgain}
          >
            {this.props.buttonLabel || 'Start Again'}
          </button>
        </div>
      </div>
    );
  }
}

export default SessionExpiredPopup;
